<template>
  <div class="add-project-button">
        <section 
        :class="[shit$(`px:13px; lh:30px; h:30px; otl:n; bgc:rgba(14, 211, 255, 0.6); radius:18.5px;`), !popperVisible || shit$(`lh:26px; border:2px solid; bc:#a8a8ac; bgc:transparent;`)]" 
        @click="popperVisible = true"
        >
            <svg-icon href='#t-codelab-add-icon' :width="16" :height="16" />
            <span :class="[shit$(`vertical-a:m; ml:5px; miw:43px; dis:i-b; text-a:c; font-w:500;`)]">{{this.$t( "code-lab/component/file-management/add.vue_0" ) }}</span>
        </section>
        <add-project-popper
        v-if="popperVisible"
        :visible.sync="popperVisible"
        @add-project="$emit('addEventProxy', listData[0])"
        @add-folder="$emit('addEventProxy', listData[1])"
        @import-project="this.importProject"
        @clone-sample="cloneSample"
        ></add-project-popper>
  </div>
</template>

<script>
import importMix from "@/code-lab/component/mixins/import-mix.js";
import addProjectPopper from "@/code-lab/component/file-management/add-project-popper.vue";
export default {
  mixins: [ importMix ],
  components: {
    addProjectPopper
  },
  data () {
    return {
      listData: [
        { key: "addProject", is: 1 },
        { key: "addFile", is: 2 },
        { key: "upProject", is: 3 },
        { key: "cloneSample", is: 4 }
      ],
      popperVisible: false,
      visible: false,
    }
  },
  methods: {
    childClick(item) {
      this.visible = false
      this.$emit('addEventProxy', item)
    },
    importProject(){
      this.$emit('addEventProxy', this.listData[2]);
      this.handler();
    },
    cloneSample({projectId, name}){
      this.$emit("addEventProxy", Object.assign(this.listData[3], {params: {projectId, name}}));
    },
    handler () {
      const elm = this.creteIputElm({ accept: ['.mbkx'] })
      document.body.appendChild(elm)
      elm.click()
      elm.addEventListener('change', async et => {
        const evt = et.target.files[0]
        const notifyId = await this.execution()
        this.handleFileData(evt, notifyId)
        document.body.removeChild(elm)
      })
    }
  }
};
</script>

<style lang="scss">
.public-provide-component-add {
  width: auto;
  background-color: #272727;
  border-color: #a8a8ac;
  padding: 0px;
  padding-top: 8px;
  padding-bottom: 4px;
  border-radius: 10px;
  .el-popover__title {
    font-size: 12px;
    color: $--codelab-primary-gray-3;
    margin-bottom: 0px;
    margin-left: 12px;
  }
  .el-popover__reference {
    width: 100%;
  }
  margin-top: 18px !important;
}
.public-provide-component-add.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #272727 ;
  background-color: transparent ;
  border-top-width: 1px;
}

.public-provide-component-add.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #a8a8ac ;
}
</style>
